import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import classes from "../assets/css/vessels.module.css";
import { vesselServices } from "../services/vessels.services";
import { useDispatch } from "react-redux";
import { alertActions } from "../../_actions";
import { alertConstants } from "../../_constants";
import { Drawer } from "@mui/material";
import { encrypt } from "../../_helpers";
export default function AssociatedUsersList({
  show,
  toggle,
  sheetName,
  vesselId,
  publicKey,
  privateKey,
  vessel,
}) {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      const users = await vesselServices?.getUsersByVessel(vesselId);
      setUsers(users);
    }
    fetchData();
  }, [show, vesselId]);

  const handleUnlinkUser = async (userId) => {
    try {
      const unlink = await vesselServices?.unlinkUser(vesselId, userId);
      const { users } = await vesselServices.getVesselById(vesselId);
      if (users?.length === 0) {
        const payload = {
          sheetName: encrypt(vessel?.sheetName, publicKey, privateKey),
          vesselName: encrypt(vessel?.vesselName, publicKey, privateKey),
          vesselIMO: encrypt(vessel?.vesselIMO, publicKey, privateKey),
          vesselRegistryPort: encrypt(
            vessel?.vesselRegistryPort,
            publicKey,
            privateKey
          ),
          vesselFlag: encrypt(vessel?.vesselFlag, publicKey, privateKey),
          vesselType: encrypt(vessel?.vesselType, publicKey, privateKey),
          vesselLOA: encrypt(`${vessel?.vesselLOA}`, publicKey, privateKey),
          vesselMaxPassengersWithStaterooms: encrypt(
            `${vessel?.vesselMaxPassengersWithStaterooms}`,
            publicKey,
            privateKey
          ),
          vesselDayPassengersOnBoard: encrypt(
            `${vessel?.vesselDayPassengersOnBoard}`,
            publicKey,
            privateKey
          ),
          vesselServiceProvider: encrypt(
            vessel?.vesselServiceProvider,
            publicKey,
            privateKey
          ),
          vesselServiceProviderAddress: encrypt(
            vessel?.vesselServiceProviderAddress,
            publicKey,
            privateKey
          ),
          vesselServiceProviderCompany: encrypt(
            `${vessel?.vesselServiceProviderCompany}`,
            publicKey,
            privateKey
          ),
          vesselServiceProviderInsuranceRef: encrypt(
            vessel?.vesselServiceProviderInsuranceRef,
            publicKey,
            privateKey
          ),
          vesselServiceProviderVAT: encrypt(
            vessel?.vesselServiceProviderVAT,
            publicKey,
            privateKey
          ),
          vesselCentralAgent: encrypt(
            vessel?.vesselCentralAgent,
            publicKey,
            privateKey
          ),
          vesselCentralAgentAddress: encrypt(
            vessel?.vesselCentralAgentAddress,
            publicKey,
            privateKey
          ),
          vesselCentralAgentCompany: encrypt(
            `${vessel?.vesselCentralAgentCompany}`,
            publicKey,
            privateKey
          ),
          vesselCentralAgentInsuranceRef: encrypt(
            vessel?.vesselCentralAgentInsuranceRef,
            publicKey,
            privateKey
          ),
          vesselCentralAgentVAT: encrypt(
            vessel?.vesselCentralAgentVAT,
            publicKey,
            privateKey
          ),
          vesselCentralAgentMYBA: encrypt(
            vessel?.vesselCentralAgentMYBA,
            publicKey,
            privateKey
          ),
          vesselStakeholder: encrypt(
            vessel?.vesselStakeholder,
            publicKey,
            privateKey
          ),
          vesselStakeholderAddress: encrypt(
            vessel?.vesselStakeholderAddress,
            publicKey,
            privateKey
          ),
          vesselStakeholderCompany: encrypt(
            `${vessel?.vesselStakeholderCompany}`,
            publicKey,
            privateKey
          ),
          vesselStakeholderInsuranceRef: encrypt(
            vessel?.vesselStakeholderInsuranceRef,
            publicKey,
            privateKey
          ),
          vesselStakeholderMYBA: encrypt(
            vessel?.vesselStakeholderMYBA,
            publicKey,
            privateKey
          ),
          vesselStakeholderVAT: encrypt(
            vessel?.vesselStakeholderVAT,
            publicKey,
            privateKey
          ),
          vesselStakeholderFinancialGuarantee: encrypt(
            vessel?.vesselStakeholderFinancialGuarantee,
            publicKey,
            privateKey
          ),
          vesselSpecialConditions: encrypt(
            vessel?.vesselSpecialConditions,
            publicKey,
            privateKey
          ),
        };
        await vesselServices.update(payload, vesselId);
      }
      dispatch(alertActions.setAlert(t(unlink), alertConstants.SUCCESS));
      const usersRes = await vesselServices?.getUsersByVessel(vesselId);
      setUsers(usersRes);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Drawer open={show} onClose={toggle} anchor="right">
      <div className={classes?.drawer}>
        <span className={classes?.listGroupTitle}>
          <i className="fa fa-anchor"></i> {sheetName} -{" "}
          {t("List of associated users")}
        </span>

        <Table bordered hover style={{ textAlign: "center" }}>
          <thead>
            <tr
              style={{
                textAlign: "center",
                backgroundColor: "#e9725b",
                color: "#FFFFFF",
              }}
            >
              <th>{t("Email")}</th>
              <th>{t("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {users?.map((user, index) => (
              <tr key={index}>
                <td>{user?.user_email}</td>
                <td>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => handleUnlinkUser(user?.user_id)}
                  >
                    <i className="fa fa-user-minus"></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Drawer>
  );
}
